import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@mui/material";
import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CardPerguntas from "../../components/cardPerguntas/cardperguntas";
import CardResumePerguntas from "../../components/cardResumePerguntas/cardResumePerguntas";
import Loading from "../../components/loading/loading";
import { AuthContext } from "../../contexts/auth";
import { ManagerProgressContext } from "../../contexts/managerProgres";
import { AdminContext } from "../../contexts/temasAdminContext";
import configeToken from "../../services/api";
import "./_perguntas.scss";
import moment from "moment";

function Perguntas() {
    const { updateToken, logoutLogin, cyrcleStorage } = useContext(AuthContext);
    const { getProgress, concluded, lastTheme, quizzEndDate, dataTemas } = useContext(
        ManagerProgressContext,
    );
    const { subTema, setSubTema, subTemaId } = useContext(AdminContext);
    const [dataTema, setDataTema] = useState([]);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [newRender, setNewRender] = useState(false);
    const [permission, setPermission] = useState(false);
    const { id } = useParams();
    const navigate = useNavigate();
    const [finishTema, setFinishTema] = useState([]);
    const [open, setOpen] = useState(false);
    const isQuizzExpired = moment(quizzEndDate, "YYYY-MM-DD HH:mm:ss").isBefore(
        moment(),
    );

    const themeIds = dataTemas.map((t) => t.id);
    const currentIndex = themeIds.indexOf(Number(id));
    const isFirstTheme = currentIndex === 0;
    const isLastTheme = currentIndex === themeIds.length - 1 && themeIds.length > 0;
    const prevThemeId = !isFirstTheme ? themeIds[currentIndex - 1] : null;
    const nextThemeId = !isLastTheme ? themeIds[currentIndex + 1] : null;
    const allThemesDone =
        dataTemas.length > 0 &&
        dataTemas.every((el) => Math.round(el.progress) === 100);

    function goToTheme(themeId) {
        navigate(`/questionario/${themeId}`);
    }

    // if (isQuizzExpired) {
    //     navigate("/relatorio");
    // }

    useEffect(() => {
        document.title = "Abrafati - Questionário";
        const userStorage = JSON.parse(localStorage.getItem("@user"));
        const permissions = userStorage?.permissions || [];
        const hasPermission = permissions.some((permissao) => permissao.id === 2);

        if (hasPermission) {
            setPermission(true);
        } else {
            console.warn(`[REDIRECT] Perguntas (/questionario/${id}): Usuário não possui permissão para acessar o questionário (permissão id: 2). Redirecionando para /.`, {
                currentPath: `/questionario/${id}`,
                user: userStorage,
                permissions: permissions,
            });
            toast.info("Seu perfil de acesso não possui permissão para preencher o questionário.", {
                toastId: "sem-permissao-acesso",
            });
            navigate("/");
        }
    }, [id, navigate]);

    useEffect(() => {
        setRemoveLoading(false);
        window.scroll({ top: 0 });
    }, [id]);

    useEffect(() => {
        if (!id) return;

        const userStorage = JSON.parse(localStorage.getItem("@user"));
        const permissions = userStorage?.permissions || [];
        const hasPermission = permissions.some((permissao) => permissao.id === 2);
        if (!hasPermission) return;

        updateToken()
            .then(() => getProgress())
            .then(() => configeToken())
            .then((response) => {
                const headers = {
                    Authorization: ``,
                    "Content-Type": "application/json",
                    Accept: "application/json",
                };

                axios({
                    method: "get",
                    url: `${process.env.REACT_APP_API_URL}/tema/${id}`,
                    headers,
                })
                    .then((response) => {
                        const tema = response.data.data;
                        setDataTema(tema);
                        setSubTema(tema.id || Number(id));

                        setRemoveLoading(true);

                        let percentualQuestions = tema.subthemes
                            ?.map((el) => {
                                return el.progress;
                            })
                            .filter((el) => el !== 100).length;

                        setFinishTema(!!percentualQuestions);
                    })
                    .catch(() => { });
            })
            .catch((error) => {
                if (error.response && error.response.status === 401) {
                    logoutLogin();
                }
            });
    }, [
        id,
        newRender,
        subTemaId,
        setSubTema,
        updateToken,
        getProgress,
        logoutLogin,
        navigate,
    ]);

    useEffect(() => {
        if (cyrcleStorage > 1 && Number(id) <= 4) {
            navigate(`/questionario/${Number(id) + 4}`);
        }
        if (cyrcleStorage === 1 && Number(id) > 4) {
            navigate(`/questionario/${Number(id) - 4}`);
        }
    }, [cyrcleStorage, id, navigate]);

    async function postDataQuestion(question_id, option_id) {
        let dateQuestion = JSON.parse(localStorage.getItem("@tetse"));
        let question_idStorage = dateQuestion && dateQuestion[0];
        let option_idStorage = dateQuestion && dateQuestion[1];

        const headers = {
            Authorization: `Bearer ${localStorage.getItem("@token")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
        };

        let body;

        if (question_id) {
            body = {
                quiz_id: cyrcleStorage,
                question_id: question_id,
                option_id: option_id,
            };
        } else {
            body = {
                quiz_id: cyrcleStorage,
                question_id: question_idStorage,
                option_id: option_idStorage,
            };
        }

        let responseFetch;
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/resposta`,
                {
                    method: "POST",
                    headers,
                    body: JSON.stringify(body),
                },
            );
            responseFetch = await response.json();

            setNewRender(!newRender);

            if (response.ok) {
                toast.success("Salvo com sucesso!", {
                    position: "bottom-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
            } else {
                throw responseFetch;
            }

            if (!response.ok) {
                throw responseFetch;
            }
        } catch (error) {
            toast.warn(`${error}`, {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    }

    async function endSearch(quiz_id) {
        const headers = {
            Authorization: `Bearer ${localStorage.getItem("@token")}`,
            "Content-Type": "application/json",
            Accept: "application/json",
        };

        let body = {
            quiz_id: quiz_id,
        };

        let responseFetch;
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/finalizar`,
                {
                    method: "POST",
                    headers,
                    body: JSON.stringify(body),
                },
            );
            responseFetch = await response.json();

            setNewRender(!newRender);

            if (response.ok) {
                toast.success(responseFetch.message, {
                    position: "bottom-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                getProgress();
            } else {
                throw responseFetch;
            }

            if (!response.ok) {
                throw responseFetch;
            }
        } catch (error) {
            toast.warn(responseFetch.message, {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleConfirmFinalize = () => {
        endSearch(cyrcleStorage);
        handleClose();
    };

    return (
        <section className="container-perguntas">
            <div className="main-perguntas">
                {!removeLoading ? (
                    <Loading />
                ) : (
                    <>
                        {permission ? (
                            <>
                                <CardResumePerguntas
                                    title={dataTema.title}
                                    description={dataTema.description}
                                    image={dataTema.image}
                                    progress={Math.round(dataTema.progress)}
                                    color={`color-${subTema}`}
                                    bg={`bg-${subTema}`}
                                />
                                {dataTema.subthemes.map((el) => (
                                    <CardPerguntas
                                        finishTema={finishTema}
                                        postDataQuestion={postDataQuestion}
                                        key={el.id}
                                        questions={el.questions}
                                        title={el.title}
                                        id={el.id}
                                        color={`color-${subTema}`}
                                        bg={`bg-${subTema}`}
                                    />
                                ))}
                            </>
                        ) : null}
                    </>
                )}

                {removeLoading && (
                    <div className="btn-navigation">
                        <div className="btn-navigation-left">
                            {!isFirstTheme && (
                                <button
                                    onClick={() => goToTheme(prevThemeId)}
                                    className="btn-nav"
                                    type="button"
                                >
                                    Anterior
                                </button>
                            )}
                        </div>
                        <div className="btn-navigation-right">
                            {isLastTheme ? (
                                !finishTema &&
                                !concluded &&
                                allThemesDone && (
                                    <button
                                        onClick={handleClickOpen}
                                        className="btn-send-request"
                                        type="button"
                                    >
                                        Finalizar
                                    </button>
                                )
                            ) : (
                                <button
                                    onClick={() => goToTheme(nextThemeId)}
                                    className="btn-nav"
                                    type="button"
                                >
                                    Próximo
                                </button>
                            )}
                        </div>
                    </div>
                )}

                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Finalizando questionário"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Ao confirmar você finalizará o questionário, deseja
                            continuar?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Não</Button>
                        <Button onClick={handleConfirmFinalize} autoFocus>
                            Confirmar
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </section>
    );
}

export default Perguntas;

